import React from 'react';
import "../../styles/chats/conversations.css";
import { useState, useEffect, useRef } from "react";
import { useSearchContext } from "./searchContext";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, setDoc, updateDoc, arrayUnion, onSnapshot, deleteField, getDocs, collection } from "firebase/firestore";
import { firebaseAuth } from "../firebase/firebase_configuration";
import { firebaseFirestore } from "../firebase/firebase_configuration";
import {cloudinaryConfig} from "../cloudinary/cloudinary_config"
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import MessageDropDown from "./message_dropdown";
import ReactionDialog from "./reaction_dialog";
import DeleteMessage from "./delete_message";
import ReactionBubble from "./reaction_bubble";
import SendImageDialog from "./send_image_dialog";

import addImageIcon from "../../images/chats/add_image.png";
import messagesIcon from "../../images/chats/message_icon.png"
import sendMessageIcon from "../../images/chats/send_message_icon.png";
import profileImage from "../../images/authentication/no_profile.png";

const Conversations = () => {
    const navigate = useNavigate();
    const messagesEndRef = useRef(null);  
    const fileInputRef = useRef(null);
    const {getUserId, getSelectedEmoji, setSelectedEmoji} = useSearchContext();
    const [getConMessages, setConMessages] = useState([]);
    const [getConPUserId, setConPUserId] = useState("");
    const [setConPUserImage] = useState("");
    const [setConPUsername] = useState("");
    const [getConUserId, setConUserId] = useState("");
    const [getConUserImage, setConUserImage] = useState("");
    const [getConUsername, setConUsername] = useState("");
    const [getTypedMessage, setTypedMessage] = useState("");
    const [getChatId, setChatId] = useState("");
    const [getSendMessageImage, setSendMessageImage] = useState("");
    const [getSelectedMessageIndex, setSelectedMessageIndex] = useState(0);
    const [getIsMessageDropDownShow, setIsMessageDropDownShow] = useState(false);
    const [getIsReactionDropDownShow, setIsReactionDropDownShow] = useState(false);
    const [getIsMessageDeleteShow, setIsMessageDeleteShow] = useState(false);
    const [getIsReactionBubbleShow, setIsReactionBubbleShow] = useState(true);
    const [getIsSendImageDialog, setIsSendImageDialog] = useState(false);

    const onTypedMessageChanged = (message) => {
        setTypedMessage(message.target.value);
    }

    const onMessageDropDown = (show, index) => {
        setSelectedMessageIndex(index);
        setIsMessageDropDownShow(show);
    };

    const onMessageReact = (show, index) => {
        setSelectedMessageIndex(index);
        setIsReactionDropDownShow(show);
    };

    const onSelectMessageImage = () => {
        fileInputRef.current.click();
    }

    const selectMessageImage = (event) => {
        const file = event.target.files[0];
        if (file) {
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
            if (validImageTypes.includes(file.type)) {
                const fileReader = new FileReader();
                fileReader.onloadend = () => {
                    setSendMessageImage(fileReader.result);
                };
                fileReader.readAsDataURL(file);
                setIsSendImageDialog(true);
            } else {
                alert('Please select a valid image file (JPEG, PNG, GIF, BMP, WebP)');
            }
        }
    }

    const onSendUploadImage = async () => {
        setIsSendImageDialog(false);
        try {
            const formData = new FormData();
            formData.append("file", getSendMessageImage);
            formData.append("upload_preset", `${cloudinaryConfig.upload_preset}`);
            const imageResponse = await Axios.post(`https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloud_name}/image/upload`, formData);

            const data = await imageResponse.data;
            if (data.secure_url) {
                onSendStoreImageUrl(data.secure_url);
                // setIsSendImageDialog(false);
            }else{
                setSendMessageImage("");
                // setIsSendImageDialog(false);
            }
        } catch (error) {
            console.error('Error uploading image to Cloudinary:', error);
            setSendMessageImage("");
            alert("Image not sent.");
            // setIsSendImageDialog(false);
        }
    }

    const onSendStoreImageUrl = async (url) => {
        try {
            const messagesRef = doc(firebaseFirestore, 'User Chats', getChatId);
            const messageData = {
                senderId: getConPUserId,
                content_image: url,
            };

            const docSnap = await getDoc(messagesRef);
            if (docSnap.exists()) {
                const currentMessages = docSnap.data().messages || [];
                const updatedMessages = [...currentMessages, messageData];

                await updateDoc(messagesRef, {
                    [`message${Date.now().toString()}`]: updatedMessages,
                });
                setTypedMessage(''); 
                setSendMessageImage("");
                // setIsSendImageDialog(false);
            }else{
                await setDoc(messagesRef, {
                    [`message${Date.now().toString()}`]: messageData,
                });
                setTypedMessage(''); 
                setSendMessageImage("");
                // setIsSendImageDialog(false);
            }
        } catch (error) {
            console.error('Error sending message: ', error.message, 'Chat Id: ', getChatId);
            setSendMessageImage("");
            setIsSendImageDialog(false);
        }
    }

    const onSelectMessageReaction = async () => {
        try {
            const messagesRef = doc(firebaseFirestore, 'User Chats', getChatId);
            const docSnap = await getDoc(messagesRef);
            if (docSnap.exists()) {
                const chatData = docSnap.data();
                Object.keys(chatData).forEach((fieldName) => {
                    getConMessages.map(async (msg, index) => {
                        
                        if (fieldName === `message${msg.timestamp}` && getSelectedMessageIndex === index) {
                            const messageData = chatData[fieldName][0];
                            const existingReactions = { ...messageData };
                            const reactionField = `reaction${getConPUserId}`;
                            existingReactions[reactionField] = getSelectedEmoji;
                            await updateDoc(messagesRef, {
                                [`${fieldName}.0`]: existingReactions,
                            }, { merge: true });
                        }
                    });
                });
                
                setIsMessageDropDownShow(false);
                setIsReactionDropDownShow(false);
                setIsMessageDeleteShow(false);
                setSelectedEmoji("");
            }
        } catch (error) {
            console.error('Error deleting message: ', error.message);
        }
    };

    const onSelectMessageDelete = async () => {
        try {
            const messagesRef = doc(firebaseFirestore, 'User Chats', getChatId);
    
            const docSnap = await getDoc(messagesRef);
            if (docSnap.exists()) {
                const chatData = docSnap.data();
                Object.keys(chatData).forEach((fieldName) => {
                    getConMessages.map(async (msg, index) => {
                        if (fieldName === `message${msg.timestamp}` && getSelectedMessageIndex === index) {
                            await updateDoc(messagesRef, {
                                [`message${msg.timestamp}`]: deleteField(),
                            }, {merge: true});
                        }
                    });
                });
                
                setIsMessageDropDownShow(false);
                setIsReactionDropDownShow(false);
                setIsMessageDeleteShow(false);
            }
        } catch (error) {
            console.error('Error deleting message: ', error.message);
        }
    };

    const onMessageDelete = () => {
        setIsMessageDropDownShow(false);
        setIsReactionDropDownShow(false);
        setIsMessageDeleteShow(true);
    };

    const onClickScreen = (event) => {
        let clickedInsideMessage = false;
        const dropdownElement = document.querySelector('.con_message_dropdown');
        
        if (dropdownElement && dropdownElement.contains(event.target)) {
            clickedInsideMessage = true;
        }

        if (!clickedInsideMessage) {
            setIsMessageDropDownShow(false);
            setIsReactionDropDownShow(false);
        }
    }

    const getConUserDetails = async (id, person) => {
        try {
          const userRef = doc(firebaseFirestore, "User Details", id);
          const userSnapshot = await getDoc(userRef);
    
          if (userSnapshot.exists()) {
            if (person == "user") {
                setConPUserId(id);
                setConPUsername(userSnapshot.data().username ?? "");
                setConPUserImage(userSnapshot.data().image ?? "");
            } else {
                setConUserId(id);
                setConUsername(userSnapshot.data().username ?? "");
                setConUserImage(userSnapshot.data().image ?? "");
            }
          }
        } catch (error) {
          console.log(`${error.message}; User Id: ${id}`);
        }
    };

    const onGoBack = () => {
        navigate(-1)
    };

    const getConChatId = async () => {
        try {
            const userRef = doc(firebaseFirestore, "User Details", getConPUserId);
            const userSnapshot = await getDoc(userRef);
      
            if (userSnapshot.exists()) {
                const chats = userSnapshot.data().chats || [];
                const chat = chats.find(chatEntry => {
                  return Object.keys(chatEntry).includes(getConUserId);
                });
          
                if (chat) {
                    setChatId(chat[getConUserId]);
                } 
            } 
        } catch (error) {
            console.log(`${error.message}`);
        }
    };

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const options = {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        };
        return date.toLocaleDateString('en-GB', options);
    };

    const formatTime = (timestamp) => {
        const time = new Date(timestamp);
        const options = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true 
        };
        return time.toLocaleTimeString('en-GB', options);
    };


    const generateRandomString = (length = 10) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };

    const setConChatId = async () => {
        try {
            const querySnapshot = await getDocs(collection(firebaseFirestore, "User Chats"));
            const userRef = doc(firebaseFirestore, "User Details", getConPUserId);
            const userDoc = await getDoc(userRef);
            const userConRef = doc(firebaseFirestore, "User Details", getConUserId);

            if (userDoc.exists()) {
                let uniqueRandomString;
                let isUnique = false;

                querySnapshot.forEach((doc) => {
                    uniqueRandomString = generateRandomString();
                    isUnique = !(doc.id === uniqueRandomString);
                });

                const chatEntry = { [getConUserId]: uniqueRandomString };
                const chatConEntry = { [getConPUserId]: uniqueRandomString };
                await updateDoc(userRef, {
                    "chats": arrayUnion(chatEntry)
                });

                await updateDoc(userConRef, {
                    "chats": arrayUnion(chatConEntry)
                });
                getConChatId();
            } 
        } catch (error) {
            console.log(`Chat not created!: ${error.message}`);
        }
    };

    const sendMessage = async () => {
        try {
            const messagesRef = doc(firebaseFirestore, 'User Chats', getChatId);
            const messageData = {
                senderId: getConPUserId,
                content: getTypedMessage,
            };

            const docSnap = await getDoc(messagesRef);
            if (docSnap.exists()) {
                const currentMessages = docSnap.data().messages || [];
                const updatedMessages = [...currentMessages, messageData];

                await updateDoc(messagesRef, {
                    [`message${Date.now().toString()}`]: updatedMessages,
                });
                setTypedMessage(''); 
            }else{
                await setDoc(messagesRef, {
                    [`message${Date.now().toString()}`]: [messageData],
                });
                setTypedMessage(''); 
            }
        } catch (error) {
            console.error('Error sending message: ', error.message, 'Chat Id: ', getChatId);
        }
    };

    const onSendMessage = async () => {
        if(getTypedMessage.trim() != ""){
            if (getChatId !== "") {
                sendMessage();
            }else{
                setConChatId().then(() => {
                    setTimeout(() => {
                        sendMessage();
                    }, 2000);
                }).catch((error) => {
                    alert("Message not sent.");
                    console.log(`Message not sent!: ${error.message}`);
                });
            }
        }
    };

    useEffect(() => {
        if (getUserId === "" || getUserId === null) {
            navigate("/main_back/chats", {replace: true});
        }
    }, [getUserId]);

    useEffect(() => {
        getConUserDetails(getUserId, "con");

        const getUser = onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                getConUserDetails(user.uid, "user");
            }
        });
        
        return () => getUser();
    }, []);

    useEffect(() => {
        getConChatId();
    }, [getConChatId]);

    useEffect(() => {
        if (getChatId != "") {
            const messagesRef = doc(firebaseFirestore, 'User Chats', getChatId);
            const unsubscribe = onSnapshot(messagesRef, (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const chatData = docSnapshot.data();
                    let messagesArray = [];
                    Object.keys(chatData).forEach((fieldName) => {
                        if (fieldName.startsWith("message")) {
                            const message = chatData[fieldName][0];  
                            const timestamp = parseInt(fieldName.replace('message', ''), 10);
                            messagesArray.push({ ...message, timestamp });
                        }
                    });

                    messagesArray.sort((a, b) => a.timestamp - b.timestamp);
                    setConMessages(messagesArray);
                }
            });
    
            return () => unsubscribe();
        }
    }, [getChatId]);

    useEffect(() => {
        const messageContainer = document.querySelector('.con_messages_block');
        if (messageContainer) {
            messageContainer.scrollTop = messageContainer.scrollHeight;
        }
    }, [getConMessages]);

    useEffect(() => {
        if (getSelectedEmoji !== "") {
            onSelectMessageReaction();
        }
    }, [getSelectedEmoji]);

    return(
        <div className="conversations_screen" onClick={onClickScreen}>
            <div className="conversations_nav_section">
                <img alt="profile" className="con_user_image" src={getConUserImage === "" || getConUserImage === null ? profileImage : getConUserImage} />
                <p className="con_user_name" >{getConUsername}</p>
                <p className="con_back_arrow" onClick={onGoBack}>back</p>
            </div>

            {
                getConMessages.length > 0
                ? <div className="con_messages_block" ref={messagesEndRef}>
                    {getConMessages.map((msg, index) => {
                        const currentDate = formatDate(msg.timestamp);
                        const messageTime = formatTime(msg.timestamp);
                        const previousMessage = getConMessages[index - 1];
                        const previousDate = previousMessage ? formatDate(previousMessage.timestamp) : null;

                        return (
                            <div key={index}>
                                {currentDate !== previousDate && (
                                    <div className="text_message_seperator">
                                        <p>{currentDate}</p>
                                    </div>
                                )}
                                
                                {msg.content != null && msg.content !== "" && (
                                    <div className="text_messages" id={msg.senderId === getConPUserId ? 'sendMessageAnim' : 'receiveMessageAnim'} style={{ marginLeft: msg.senderId === getConPUserId ? '100px' : '0', marginRight: msg.senderId === getConPUserId ? '20px' : '100px', alignItems: msg.senderId === getConPUserId ? 'end' : 'start' }}>
                                        <p onClick={(e) => {e.stopPropagation(); onMessageReact(false, index); onMessageDropDown(true, index)}} className="con_message_content">{msg.content}</p>
                                        <p className="con_message_time">{messageTime}</p>
                                    </div>
                                )}

                                {msg.content_image != null && msg.content_image !== "" && (
                                    <div className="text_messages" id={msg.senderId === getConPUserId ? 'sendMessageAnim' : 'receiveMessageAnim'} style={{ marginLeft: msg.senderId === getConPUserId ? '100px' : '0', marginRight: msg.senderId === getConPUserId ? '20px' : '100px', alignItems: msg.senderId === getConPUserId ? 'end' : 'start' }}>
                                        <img alt='sent image' onClick={(e) => {e.stopPropagation(); onMessageReact(false, index); onMessageDropDown(true, index)}} className="con_message_content_image" src={msg.content_image} />
                                        <p className="con_message_time">{messageTime}</p>
                                    </div>
                                )}

                                <div className="reaction_bubble_row" style={{ marginLeft: msg.senderId === getConPUserId ? '100px' : '0', marginRight: msg.senderId === getConPUserId ? '20px' : '100px', justifyContent: msg.senderId === getConPUserId ? 'end' : 'start' }}>
                                    {getIsReactionBubbleShow && msg[`reaction${getConPUserId}`] !== null && (
                                        <div className="reaction_bubble" >
                                            <ReactionBubble isReactionBubbleShow={getIsReactionBubbleShow} reaction={msg[`reaction${getConPUserId}`]} />
                                        </div>
                                    )}
                                    {getIsReactionBubbleShow && msg[`reaction${getConUserId}`] !== null && (
                                        <div className="reaction_bubble" >
                                            <ReactionBubble isReactionBubbleShow={getIsReactionBubbleShow} reaction={msg[`reaction${getConUserId}`]} />
                                        </div>
                                    )}
                                </div>

                                {getIsMessageDropDownShow && getSelectedMessageIndex === index && (
                                    <div className="con_message_dropdown" style={{justifySelf: msg.senderId === getConPUserId ? 'end' : 'start'}}>
                                        <MessageDropDown isMessageDropDownShow={getIsMessageDropDownShow} setMessageDropDownShow={setIsMessageDropDownShow} canDelete={msg.senderId === getConPUserId ? true : false} onReact={() => {onMessageReact(true, index); onMessageDropDown(false, index)}} onDelete={onMessageDelete} />
                                    </div>
                                )}

                                {getIsReactionDropDownShow && getSelectedMessageIndex === index && (
                                    <div  style={{justifySelf: msg.senderId === getConPUserId ? 'end' : 'start'}}>
                                        <ReactionDialog isisReactionDropDownShow={getIsReactionDropDownShow} />
                                    </div>
                                )}

                                {getIsMessageDeleteShow && getSelectedMessageIndex === index && (
                                    <div>
                                        <DeleteMessage isDeleteMessageDialogShow={getIsMessageDeleteShow} setDeleteMessageDialogShow={setIsMessageDeleteShow} onDelete={() => onSelectMessageDelete()} />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
                : <div className="no_chats_section">
                    <img alt='No message' src={messagesIcon} />
                    <p>No messages yet.</p>
                </div>
            }

            <div className="con_message_input_container">
                <img alt='select' src={addImageIcon} onClick={onSelectMessageImage} className="con_message_input_icon"/>
                <input className="con_message_input_field" placeholder="Type a message" type="text" value={getTypedMessage} onChange={onTypedMessageChanged} />
                <img alt='send' src={sendMessageIcon} className="con_message_send_icon" onClick={onSendMessage}/>
                <input ref={fileInputRef} type="file" style={{display: 'none'}} onChange={selectMessageImage} />
            </div>
            {getIsSendImageDialog && getSendMessageImage !== "" && getSendMessageImage !== null && (
                <div>
                    <SendImageDialog image={getSendMessageImage} isSendImageDialogShow={getIsSendImageDialog} onDiscard={setIsSendImageDialog} onSend ={() => onSendUploadImage()} />
                </div>
            )};
        </div>
    );
};

export default Conversations;